/**
 * Utility function to assert that a value is of type `never`, which is useful for exhaustive checks in switch statements.
 * If the function is called, it means that there is a case that was not handled, and it will throw an error with the unexpected value.
 * @param x The value that should be of type `never`.
 * @returns This function never returns; it always throws an error.
 * @example
 *   type Shape = 'circle' | 'square';
 *
 *   function getArea(shape: Shape) {
 *     switch (shape) {
 *       case 'circle':
 *         return Math.PI * 1; // Example area for a circle with radius 1
 *       case 'square':
 *         return 1 * 1; // Example area for a square with side length 1
 *       default:
 *         assertUnreachable(shape, `Unhandled shape: ${shape}`); // This will cause a compile-time error if a new shape is added to the Shape type but not handled in the switch
 *     }
 *   }
 */
export function assertUnreachable(x: never, message?: string): never {
  throw new Error(message ?? 'Unknown value: ' + x);
}
